import { render, staticRenderFns } from "./ImagePair.vue?vue&type=template&id=602eb056"
import script from "./ImagePair.vue?vue&type=script&lang=js"
export * from "./ImagePair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default})
